import axios, { all } from "axios";

//@ts-ignore
// const { Temporal } = temporal;

export const pathRoutes = {
  login: "/login",
  main: "/main",
  summary: "/summary",
  lotSummary: "/lot-summary",
  numberLotSummary: "/number-lot-summary",
  check: "/check",
  main_s1: "/main_s1",
  selectUser: "/select-user",
  lotResualt: "/lot-resualt",
  lotResualtSet: "/lot-resualt-set",
  lotResualtSet2: "/version2-resualt",
};
export const AuthKeys = {
  token: "token",
  expiresDate: "expiresDate",
  tokenType: "tokenType",
  cardBgColor: "card_bg_color",
};

export function saveToken({ token, tokenType, expiresDate }) {
  localStorage.setItem(AuthKeys.token, token);
  localStorage.setItem(AuthKeys.tokenType, tokenType);
  localStorage.setItem(AuthKeys.expiresDate, expiresDate);

  let user = parseJwt(token);
  if (!checkEmpty(user?.user?.card_bg_color)) {
    localStorage.setItem(AuthKeys.cardBgColor, user?.user?.card_bg_color);
  }
}
export const getAuthorization = () => {
  let token = getToken();
  let authorization = "Bearer " + token;

  return authorization;
};
export const checkEmpty = (val) => {
  if (
    val === undefined ||
    val === null ||
    val === "null" ||
    val === "undefined"
  )
    return true;
  if (val.length === 0) return true;

  return false;
};
export function getToken() {
  return (
    localStorage.getItem(AuthKeys.token) ||
    sessionStorage.getItem(AuthKeys.token)
  );
}

export function clearToken() {
  localStorage.removeItem(AuthKeys.token);
  sessionStorage.removeItem(AuthKeys.token);
  sessionStorage.removeItem(AuthKeys.cardBgColor);
}

export function setToken(token) {
  localStorage.setItem(AuthKeys.token, token);
}

export const newDateUtil = (dateString) => {
  // const dateString = "2015-12-31 00:00:00";
  if (checkEmpty(dateString)) return new Date();

  let dt;
  let type = typeof dateString;
  // console.log("typeof", type);
  // console.log("dateString", dateString);
  if ("object" == type) return dateString;
  else if ("string" == type) {
    dateString = dateString.replace(" ", "T");
  }

  dt = new Date(dateString);
  return dt;
};
export const checkAuth = () => {
  // let token: any = getToken();
  // console.log("token : ",token);
  // if (checkEmpty(token)) {
  //   return false;
  // } else {
  //   localStorage.setItem(AuthKeys.token, token);
  //   sessionStorage.setItem(AuthKeys.token, token);
  //   return true;
  // }
  // const me = await api.get(UserAPIEndpoint.Me);
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/me";
    let data = { message: "", status: false };
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        console.log("checkAuth", res);
        if (res.status != 200) {
          data.status = false;
          data.message = res.data?.message;
          resolve(data);
        } else {
          data.status = true;
          resolve(data);
        }
      })
      .catch((e) => {
        console.log("checkAuth err=>", e);
        data.status = false;
        data.message = e?.response?.data?.message;
        resolve(data);
      });
  });
};

export function getUserMe() {
  return parseJwt(getToken());
}
export function isAdmin() {
  let user = getUserMe();
  if (user?.user.role_name == "admin") {
    return true;
  } else {
    return false;
  }
}
export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export const getOrders = (datefrom, dateto, acUsername, isLastTop) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot?datefrom=${datefrom}&&dateto=${dateto}&&username=${acUsername}&&isLastTop=${isLastTop}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getRrderDetails = (lot_order_id) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-order-details?lot_order_id=${lot_order_id}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};
export const getOrdersV3 = (
  datefrom,
  dateto,
  acUsername,
  isLastTop,
  lotids,
  istype
) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-summary-v3?datefrom=${datefrom}&&dateto=${dateto}&&username=${acUsername}&&isLastTop=${isLastTop}&&lotids=${lotids}&&istype=${istype}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getOrdersV3Bil5 = (datefrom, dateto, acUsername) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-bill5-v3?datefrom=${datefrom}&&dateto=${dateto}&&username=${acUsername}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getOrdersV2 = (
  datefrom,
  dateto,
  acUsername,
  isLastTop,
  lotids,
  istype
) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-v2?datefrom=${datefrom}&&dateto=${dateto}&&username=${acUsername}&&isLastTop=${isLastTop}&&lotids=${lotids}&&istype=${istype}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getLotResults = (datefrom, dateto) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-result?datefrom=${datefrom}&&dateto=${dateto}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getPreventLot = (lotSelected, acUsername) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-prevent?lot_id=${lotSelected}&&username=${acUsername}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getUsers = () => {
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + `/v1/get-users`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getAboutLot = () => {
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/about-lots";
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};
export const getUpdateLog = () => {
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/get-updatelog";
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const initApi = () => {
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/init";
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getLot = (id, acUsername) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      "/v1/lot?lot_id=" +
      id +
      "&username=" +
      acUsername;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getLotResualts = (id) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      "/v1/find-lot-resualt-10?lot_id=" +
      id;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getCurrentDateUtil = () => {
  const date = newDateUtil();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }

  // This arrangement can be altered based on how we want the date's format to appear.
  // let currentDate = `${day}-${month}-${year}`;
  let currentDate = `${year}-${month}-${day}`;
  return currentDate;
};
export const getCurrentDateUtilYYYY = () => {
  const date = newDateUtil();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month}-${day}`;
  return currentDate;
};
export const getDateUtilYYYYBydate = (date) => {
  // const date = newDateUtil();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month}-${day}`;
  return currentDate;
};

export const getDateUtilYYYYTimeNow = () => {
  const date = newDateUtil();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }
  let h = date.getHours();
  if (h < 10) {
    h = "0" + h + "";
  }
  // ":" +
  let m = date.getMinutes();
  if (m < 10) {
    m = "0" + m + "";
  }
  // ":" +
  let s = date.getSeconds();
  if (s < 10) {
    s = "0" + s + "";
  }
  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month}-${day} ${h}:${m}:${s}`;
  return currentDate;
};
export const getDateUtilYYYYTime = (dateText) => {
  // console.log("dateText",dateText)
  const date = newDateUtil(dateText);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }
  let h = date.getHours();
  if (h < 10) {
    h = "0" + h + "";
  }
  // ":" +
  let m = date.getMinutes();
  if (m < 10) {
    m = "0" + m + "";
  }
  // ":" +
  let s = date.getSeconds();
  if (s < 10) {
    s = "0" + s + "";
  }
  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month}-${day} ${h}:${m}:${s}`;
  return currentDate;
};

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const getDateUtilYYYY = (dateText) => {
  const date = newDateUtil(dateText);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (month < 10) {
    month = "0" + month + "";
  }
  if (day < 10) {
    day = "0" + day + "";
  }
  // date.getHours() +
  // ":" +
  // date.getMinutes() +
  // ":" +
  // date.getSeconds()
  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month}-${day}`;
  return currentDate;
};
export function reverseString2(str) {
  if (str.length == 2) {
    if (str[0] == str[1]) return;
  }
  var newString = "";
  for (var i = str.length - 1; i >= 0; i--) {
    newString += str[i];
  }
  return newString;
}

export function reverseString3(str) {
  var newString = [];
  if (str.length < 3) return [];
  newString.push(str[0] + str[1] + str[2]);
  newString.push(str[0] + str[2] + str[1]);
  newString.push(str[1] + str[0] + str[2]);
  newString.push(str[1] + str[2] + str[0]);
  newString.push(str[2] + str[0] + str[1]);
  newString.push(str[2] + str[1] + str[0]);
  return newString;
}

export const getPrevent = (prevent_numbers, num, type) => {
  let res = null;
  if (!checkEmpty(prevent_numbers)) {
    if (type == "lot_3_tot") {
      for (let a = 0; a < prevent_numbers.length; a++) {
        if (
          reverseString3(prevent_numbers[a].prevent_number + "").includes(
            num + ""
          ) &&
          prevent_numbers[a].prevent_number_type == type
        ) {
          return { price: prevent_numbers[a].price };
        }
      }
    } else {
      for (let a = 0; a < prevent_numbers.length; a++) {
        if (
          prevent_numbers[a].prevent_number == num &&
          prevent_numbers[a].prevent_number_type == type
        ) {
          return { price: prevent_numbers[a].price };
        }
      }
    }
  }

  return null;
};

export function reverseString19(str) {
  if (str.length != 1) return [];
  var newString = [];
  // newString.push("0" + str);
  for (let a = 0; a < 10; a++) {
    newString.push(str + "" + a);
    // newString.push(a + "" + str);
  }
  for (let a = 0; a < 10; a++) {
    // newString.push(str + "" + a);
    newString.push(a + "" + str);
  }
  return newString;
}
export function indexMore(nloop, b) {
  for (let a = 0; a < nloop.length; a++) {
    if (b < nloop[a]) return false;
  }
  return true;
}

export const saveBilApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-bil";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve();
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const savePreventApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-lot-prevent";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve();
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const cancelBilApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/cancel-bil";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve();
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};
export const rmBilApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/rm-bil";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve();
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const savelotResualtApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-lot-resualt";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const savePreventNumApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-number-prevent";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const savePreventNumUsernameApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link =
      process.env.REACT_APP_SERVICE_URL + "/v1/save-number-prevent-username";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const savePreventNumAllApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link =
      process.env.REACT_APP_SERVICE_URL + "/v1/delete-number-prevent-all";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const rmlotResualtApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/rm-lot-resualt";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const rmPreventApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/delete-number-prevent";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

// export const getAboteOpen = (lot) => {
//   let res = { status: false, time: null };
//   const date = newDateUtil();
//   let timeClose = lot.lot_time_close;
//   var d1 = newDateUtil("2023-01-01, " + timeClose); //yyyy-mm-dd hh:mm:ss
//   var d2 = newDateUtil(
//     "2023-01-01, " +
//       date.getHours() +
//       ":" +
//       date.getMinutes() +
//       ":" +
//       date.getSeconds()
//   ); //yyyy-mm-dd hh:mm:ss

//   if (d1 > d2) {
//     res.time = d1 - d2;
//     res.status = true;
//   } else {
//     // console.log(lot.lot_name + " close");
//     res.status = false;
//   }
//   return res;
// };

export const subStringTextWin = (already, values, value) => {
  value = value.replace(/[^x+*0-9]/g, " ");
  console.log("after value", value);
  value = value.trim();
  values = value.split("");
  already = true;
  return { already, values, value };
};
export const subStringText = (already, values, value) => {
  value = value.replace(/[^x+*0-9]/g, " ");
  console.log("after value", value);
  if (value.indexOf(" ") != -1) {
    values = value.split(" ");
    already = true;
  } else if (value.indexOf("//") != -1) {
    values = value.split("//");
    already = true;
  } else if (value.indexOf("-") != -1) {
    values = value.split("-");
    already = true;
  } else if (value.indexOf("/") != -1) {
    values = value.split("/");
    already = true;
  } else if (value.indexOf(",") != -1) {
    values = value.split(",");
    already = true;
  } else if (value.indexOf("_") != -1) {
    values = value.split("_");
    already = true;
  } else if (value.indexOf("=") != -1) {
    values = value.split("=");
    already = true;
  }
  return { already, values, value };
};

export const getPriceDetail = (detail) => {
  let priceDetail = { price: "0", type: "" };
  if (!checkEmpty(detail.lot_top_price)) {
    priceDetail.price = detail.lot_top_price;
    priceDetail.type = "lot_top_price";
  } else if (!checkEmpty(detail.lot_bottom_price)) {
    priceDetail.price = detail.lot_bottom_price;
    priceDetail.type = "lot_bottom_price";
  } else if (!checkEmpty(detail.lot_tot_price)) {
    priceDetail.price = detail.lot_tot_price;
    priceDetail.type = "lot_tot_price";
  } else if (!checkEmpty(detail.lot_run_bottom_price)) {
    priceDetail.price = detail.lot_run_bottom_price;
    priceDetail.type = "lot_run_bottom_price";
  } else if (!checkEmpty(detail.lot_run_top_price)) {
    priceDetail.price = detail.lot_run_top_price;
    priceDetail.type = "lot_run_top_price";
  }
  return priceDetail;
};

export const getLotResultByOrderLot = (order, lotResualts) => {
  for (let a = 0; a < lotResualts.length; a++) {
    if (
      order.lot_date == lotResualts[a].lot_date &&
      order.lot_id == lotResualts[a].lot_id
    ) {
      return lotResualts[a];
    }
  }
  return null;
};
const getLotResult = (detail, lotResualts) => {
  for (let a = 0; a < lotResualts.length; a++) {
    if (
      detail.lot_date == lotResualts[a].lot_date &&
      detail.lot_id == lotResualts[a].lot_id
    ) {
      return lotResualts[a];
    }
  }
  return null;
};
export const checkDoneLot = (detail, lotResualts) => {
  let lotResualt = getLotResult(detail, lotResualts);
  let res = { status: "waiting" };
  if (checkEmpty(lotResualt)) return res;
  let lot_num = detail.lot_num;
  let lot_top = lotResualt.lot_top;
  let lot_bottom = lotResualt.lot_bottom;
  res.status = "fail";
  if (!checkEmpty(detail.lot_top_price)) {
    //2 ตัวบน ,3 ตัวบน
    if (detail.lot_sub_type == "lot_2") {
      if (lot_top?.endsWith(lot_num)) {
        res.status = "done";
      }
    }
    if (detail.lot_sub_type == "lot_3") {
      if (lot_top?.endsWith(lot_num)) {
        res.status = "done";
      }
    }
  } else if (!checkEmpty(detail.lot_bottom_price)) {
    //2 ตัวล่าง
    if (lot_bottom?.endsWith(lot_num)) {
      res.status = "done";
    }
  } else if (!checkEmpty(detail.lot_tot_price)) {
    //3 ตัวโต๊ด
    let listTot = reverseString3(lot_top);
    if (listTot?.includes(lot_num)) {
      res.status = "done";
    }
  } else if (!checkEmpty(detail.lot_run_bottom_price)) {
    //วิ่งล่าง
    if (lot_bottom?.indexOf(lot_num) != -1) {
      res.status = "done";
    }
  } else if (!checkEmpty(detail.lot_run_top_price)) {
    //วิ่งบน
    if (lot_top?.indexOf(lot_num) != -1) {
      res.status = "done";
    }
  }
  return res;
};

export const getTimeByDate = (date) => {
  let h = date.getHours();
  if (h < 10) {
    h = "0" + h + "";
  }
  // ":" +
  let m = date.getMinutes();
  if (m < 10) {
    m = "0" + m + "";
  }
  // ":" +
  let s = date.getSeconds();
  if (s < 10) {
    s = "0" + s + "";
  }
  // This arrangement can be altered based on how we want the date's format to appear.
  let time = `${h}:${m}:${s}`;
  return time;
};

export const getAboteOpenUtil = (lottemp) => {
  let lot = Object.assign({}, lottemp);
  // if (lot.lot_id == "64") console.log("lottemp", lottemp);
  let res = {
    status: false,
    time: null,
    lot_date: null,
    next: false,
    textNext: "",
    lot_id: lot.lot_id,
  };
  const date = newDateUtil();
  let timeClose = lot?.lot_time_close;
  var d1 = newDateUtil(getCurrentDateUtilYYYY() + "T" + timeClose); //yyyy-mm-dd hh:mm:ss
  var d2 = newDateUtil(getCurrentDateUtilYYYY() + "T" + getTimeByDate(date)); //yyyy-mm-dd hh:mm:ss

  res.lot_date = getCurrentDateUtilYYYY();
  if (d1 > d2) {
    res.time = d1 - d2;
    res.status = true;
  } else {
    res.status = false;
    res.time = d1 - d2;

    var time1200 = newDateUtil(getCurrentDateUtilYYYY() + "T" + "12:00:00");
    let d1date = newDateUtil(getCurrentDateUtilYYYY() + "T" + timeClose);
    // console.log("close ", d1date);
    if (d1date < time1200) {
      if (lot.date_type_allow != "1_16") {
        // console.log("<12.00 d1date", d1date);
        // console.log("time1200", time1200);
        if (date > time1200) {
          d1 = d1date.setDate(date.getDate() + 1);
          res.time = d1 - d2;
          res.status = true;
          res.lot_date = getDateUtilYYYYBydate(d1date);
          res.next = true;
          res.textNext = "[ออกพรุ่งนี้]";
          // console.log("===next", res.next);
        } else {
          res.time = d1 - d2;
        }
      }
    }
  }

  if (lot.date_type_allow === "all_days") {
    //don not thing
  } else if (lot.date_type_allow === "some_days") {
    // console.log("lot.lot_id", lot.lot_id);
    // if (lot.lot_id == "64") console.log("lot.lot_date", lot.lot_date);
    // console.log("lot.date_type_allow", lot.date_type_allow);
    if (!checkEmpty(lot.lot_date) && isJson(lot.lot_date)) {
      let days = JSON.parse(lot.lot_date);
      const d = newDateUtil();
      let day = d.getDay();
      // if (lot.lot_id == "64") console.log("===day===", day);
      if (days.includes(day)) {
        if (d1 > d2) {
          // if (lot.lot_id == "64") console.log("day 1 ", day);
          res.time = d1 - d2;
          res.status = true;
          lot.lot_date = getCurrentDateUtilYYYY();
        } else {
          // if (lot.lot_id == "64") console.log("day 2 ", day);
          res.time = null;
        }
      } else {
        // if (lot.lot_id == "64") console.log("day 3 ", day);
        res.status = false;
        res.next = false;
        res.textNext = "";
        lot.lot_date = getCurrentDateUtilYYYY();
        res.time = null;
      }
    }
  } else if (lot.date_type_allow === "1_16") {
    let lot_date = lot.lot_date;
    var timeThaiLot = newDateUtil(lot_date + "T" + timeClose);
    // console.log("timeThaiLot", timeThaiLot);
    let date = newDateUtil();
    // console.log("date", date);

    if (timeThaiLot > date) {
      // console.log("if timeThaiLot > date", (timeThaiLot > date));
      let d1date = newDateUtil(getCurrentDateUtilYYYY() + "T" + timeClose);
      d1 = d1date.setDate(date.getDate() + dayBeetweenDate(date, timeThaiLot));
      res.time = d1 - d2;
      res.status = true;
      res.lot_date = lot_date;
      res.next = false;
      res.textNext = "";
    } else {
      // console.log("else timeThaiLot > date", (timeThaiLot > date));
      res.status = false;
      res.next = false;
      res.textNext = "";
      res.lot_date = lot_date;
      res.time = null;
    }
  }

  if (!checkEmpty(res.time) && res.time > 0) {
    res.status = true;
  }

  // if (lot.lot_id == "64") console.log("res", res);
  // setLotDateStr(res.textNext);
  // setLotDate(res.lot_date);
  return res;
};

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const dayBeetweenDate = (df, dt) => {
  const date1 = df;
  const date2 = dt;
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const createUserApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/register";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const saveLotDateNextApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-lot-date";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};
export const saveLotPayApi = (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/save-lot-pay";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const getAboutLotSummaryOrderV2 = (lot, ordersRes, lotResualts) => {
  let aboutLot = {};
  let orderUses = ordersRes.filter((o) => o.lot_id == lot.lot_id);
  if (!checkEmpty(orderUses)) {
    // console.log("lot", lot);
    // console.log("orderUses", orderUses);
    // console.log("lotResualts", lotResualts);
  }

  let send_out_main = 0;
  let send_out_main_not_result = 0;
  let done_price_main = 0;
  let total_main = 0;
  let priceSumMulti = 0;
  let priceSumMultiNotResult = 0;
  let isResualtMain = "";
  let isY = false;
  for (let a = 0; a < orderUses.length; a++) {
    let isResualt = "";
    if (orderUses[a].status == "N") continue;
    let detail = orderUses[a];
    let total = orderUses[a].total;

    //**check done***
    // let doneObject = checkDoneLot(detail, lotResualts);
    // if (checkEmpty(isResualt)) {
    let lotResualt = getLotResult(detail, lotResualts);
    if (!checkEmpty(lotResualt)) {
      isResualt = "Y";
      isY = true;
    } else {
      isResualt = "N";
    }
    // }

    if (isResualt == "Y") {
      if (parseInt(orderUses[a].done_price) > 0) {
        done_price_main = done_price_main + parseInt(orderUses[a].done_price);
      } else {
      }
      send_out_main = send_out_main + parseInt(total);
      priceSumMulti = priceSumMulti + parseInt(orderUses[a].total_price_multi);
    } else {
      send_out_main_not_result = send_out_main_not_result + parseInt(total);
      priceSumMultiNotResult =
        priceSumMulti + parseInt(orderUses[a].total_price_multi);
    }
  }
  if (isY) {
    isResualtMain = "Y";
  }

  aboutLot.done_price = done_price_main;
  aboutLot.send_out = send_out_main;
  aboutLot.send_out_not_result = send_out_main_not_result;
  aboutLot.priceSumMulti = priceSumMulti;
  aboutLot.priceSumMultiNotResult = priceSumMultiNotResult;
  aboutLot.isResualt = isResualtMain;
  // aboutLot.total = done_price_main + send_out_main;
  return aboutLot;
};

export const getAboutLotSummaryOrder = (lot, ordersRes, lotResualts) => {
  let aboutLot = {};
  let orderUses = ordersRes.filter((o) => o.lot_id == lot.lot_id);
  if (!checkEmpty(orderUses)) {
    console.log("lot", lot);
    console.log("orderUses", orderUses);
    console.log("lotResualts", lotResualts);
  }

  let send_out_main = 0;
  let done_price_main = 0;
  let total_main = 0;
  for (let a = 0; a < orderUses.length; a++) {
    for (let b = 0; b < orderUses[a].orderDetails.length; b++) {
      if (orderUses[a].status == "N") continue;
      let detail = orderUses[a].orderDetails[b];
      let priceOb = getPriceDetail(detail);
      let price = priceOb?.price;
      let total = price * parseInt(detail.lot_pay);

      //**check done***
      let doneObject = checkDoneLot(detail, lotResualts);
      if (doneObject.status === "done") {
        done_price_main = done_price_main + parseInt(total);
      } else {
      }
      send_out_main = send_out_main + parseInt(price);
    }
  }

  aboutLot.done_price = done_price_main;
  aboutLot.send_out = send_out_main;
  // aboutLot.total = done_price_main + send_out_main;
  return aboutLot;
};

export const getLotsByType = (
  type,
  type_23,
  ordersRes,
  lotSelected,
  lotResualts,
  userInfo
) => {
  // console.log("lotResualts", lotResualts);
  let orders = ordersRes.filter((o) => o.lot_id == lotSelected);
  let orderType = {};
  let orderNums = [];
  let buy = 0;
  let recive = 0;
  let pay = 0;
  for (let a = 0; a < orders.length; a++) {
    for (let b = 0; b < orders[a].orderDetails.length; b++) {
      if (orders[a].status == "N") continue;
      let detail = orders[a].orderDetails[b];
      let priceOb = getPriceDetail(detail);
      if (type_23 == "lot_2" || type_23 == "lot_3") {
        if (!(priceOb.type == type && type_23 == detail.lot_sub_type)) continue;
      } else {
        if (priceOb.type != type) continue;
      }

      let orderNum = {};
      let priceTemp = priceOb.price;
      if (type_23 == "lot_2") {
        if (!checkEmpty(userInfo?.user?.multi_price)) {
          priceTemp =
            parseInt(priceTemp) * parseInt(userInfo?.user?.multi_price);
        }
      }

      orderNum.price = priceOb.price;
      orderNum.priceMulti = priceTemp;
      orderNum.lot_num = detail.lot_num;
      orderNum.lot_pay = detail.lot_pay;
      orderNums.push(orderNum);
      recive = parseInt(recive) + parseInt(priceTemp);
      buy = buy + parseInt(priceTemp);
      let total = parseInt(priceOb.price) * parseInt(detail.lot_pay);
      let calPay = 0;
      //**check done***
      // console.log("total",total)
      let doneObject = checkDoneLot(detail, lotResualts);
      // console.log("doneObject.status",doneObject.status)
      if (doneObject.status === "done") {
        calPay = calPay + parseInt(total);
      }
      pay = pay + calPay;
    }
  }
  orderType.pay = pay;
  orderType.recive = recive;
  orderType.buy = buy;

  let allNumbers = [];
  for (let a = 0; a < orderNums.length; a++) {
    let index = allNumbers.findIndex((o) => o.lot_num == orderNums[a].lot_num);
    if (index != -1) {
      allNumbers[index].price =
        parseInt(allNumbers[index].price) + parseInt(orderNums[a].price);
    } else {
      let objectNumber = {
        lot_num: orderNums[a].lot_num,
        price: parseInt(orderNums[a].price),
      };
      allNumbers.push(objectNumber);
    }
  }
  allNumbers.sort(function (a, b) {
    var keyA = parseInt(a.lot_num),
      keyB = parseInt(b.lot_num);
    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
  allNumbers.sort(function (a, b) {
    var keyA = a.price,
      keyB = b.price;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });
  orderType.allNumbers = allNumbers;
  orderType.orderNums = orderNums;
  return orderType;
};

export const logoutApi = () => {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: getAuthorization(),
    },
  };
  let link = process.env.REACT_APP_SERVICE_URL + "/v1/logout";
  console.log("link:", link);
  const data = {};
  axios
    .post(link, data, config)
    .then((res) => {})
    .catch(function (error) {})
    .finally(function () {
      // always executed
    });
};

export const getCheckHeveGetNew = async () => {
  return new Promise(async (resolve, reject) => {
    let havegetnew = false;
    try {
      let logUpdate = await getUpdateLog();
      let log_id_browser = localStorage.getItem("log_id_browser");
      let log_id = logUpdate.log_id;
      if (log_id_browser != log_id) {
        havegetnew = true;
      }
      localStorage.setItem("log_id_browser", log_id);
      resolve(havegetnew);
    } catch (e) {
      resolve(null);
    }
  });
};

export const reflectorLotTypes_2_version2 = (lottypes, lots, orders) => {
  let lottypeuses = [];

  for (let a = 0; a < lottypes.length; a++) {
    let type = lottypes[a];
    let time = null;
    for (let z = 0; z < lots.length; z++) {
      if (lots[z].lot_type == type.lot_type) {
        for (let b = 0; b < orders.length; b++) {
          if (orders[b].lot_id == lots[z].lot_id) {
            time = newDateUtil(orders[b].create_date);
            break;
          }
        }
        break;
      }
    }
    type.time = time;
    lottypeuses.push(type);
  }

  lottypeuses.sort(function (a, b) {
    var keyA = a.time,
      keyB = b.time;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });
  // console.log("lottypeuses",lottypeuses)

  return lottypeuses;
};

export const reflectorLots_2_version2 = (lots, orders) => {
  let lotuses = [];
  for (let a = 0; a < lots.length; a++) {
    let aboutOpen = getAboteOpenUtil(lots[a]);
    let data = lots[a];
    // data.time = aboutOpen.time;
    let time = null;
    for (let b = 0; b < orders.length; b++) {
      if (orders[b].lot_id == lots[a].lot_id) {
        // console.log("orders[b].create_date", orders[b].create_date);
        // console.log(
        //   "new orders[b].create_date",
        //   newDateUtil(orders[b].create_date)
        // );
        time = newDateUtil(orders[b].create_date);
        break;
      }
    }
    data.time = time;
    data.status = aboutOpen.status;
    lotuses.push(data);
  }

  lotuses.sort(function (a, b) {
    var keyA = a.time,
      keyB = b.time;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });

  let lots1 = lotuses.filter((lot) => lot.status == true);
  let lots2 = lotuses.filter((lot) => lot.status == false);
  lotuses = Object.assign([], lots2.concat(lots1));

  return lotuses;
};

export const reflectorLots_2_version3 = (lots) => {
  let lotuses = [];
  for (let a = 0; a < lots.length; a++) {
    let aboutOpen = getAboteOpenUtil(lots[a]);
    let data = lots[a];
    data.time = aboutOpen.time;
    data.status = aboutOpen.status;
    data.lot_time_close = newDateUtil(
      getCurrentDateUtilYYYY() + "T" + lots[a].lot_time_close
    );
    lotuses.push(data);
  }

  lotuses.sort(function (a, b) {
    var keyA = a.lot_time_close,
      keyB = b.lot_time_close;
    // var keyA = a.time,
    // keyB = b.time;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });

  // let lots1 = lotuses.filter((lot) => lot.status == true);
  // let lots2 = lotuses.filter((lot) => lot.status == false);
  // lotuses = Object.assign([], lots2.concat(lots1));

  // console.log("lots1", lots1);
  // console.log("lots2", lots2);
  // console.log("lotuses", lotuses);
  return lotuses;
};

export const reflectorLots_2 = (lots) => {
  let lotuses = [];
  for (let a = 0; a < lots.length; a++) {
    let aboutOpen = getAboteOpenUtil(lots[a]);
    let data = lots[a];
    data.time = aboutOpen.time;
    data.status = aboutOpen.status;
    lotuses.push(data);
  }

  lotuses.sort(function (a, b) {
    var keyA = a.time,
      keyB = b.time;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });

  let lots1 = lotuses.filter((lot) => lot.status == true);
  let lots2 = lotuses.filter((lot) => lot.status == false);
  lotuses = Object.assign([], lots2.concat(lots1));

  // console.log("lots1", lots1);
  // console.log("lots2", lots2);
  // console.log("lotuses", lotuses);
  return lotuses;
};

export const getOrderLotApi = async (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link =
      process.env.REACT_APP_SERVICE_URL + "/v1/get-lot-order-date-prevent";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const getLotsByTypeV2 = (type, type_23, ordersRes, lotSelected) => {
  let orders = ordersRes.filter((o) => o.lot_id == lotSelected);
  let orderNums = [];
  console.log("orders", orders);
  for (let a = 0; a < orders.length; a++) {
    for (let b = 0; b < orders[a].orderDetails.length; b++) {
      if (orders[a].status == "N") continue;
      let detail = orders[a].orderDetails[b];
      let priceOb = getPriceDetail(detail);
      if (type_23 == "lot_2" || type_23 == "lot_3") {
        if (!(priceOb.type == type && type_23 == detail.lot_sub_type)) continue;
      } else {
        if (priceOb.type != type) continue;
      }

      let orderNum = {};
      orderNum.price = priceOb.price;
      orderNum.lot_num = detail.lot_num;
      orderNum.lot_pay = detail.lot_pay;
      orderNums.push(orderNum);
    }
  }

  let allNumbers = [];
  for (let a = 0; a < orderNums.length; a++) {
    let index = allNumbers.findIndex((o) => o.lot_num == orderNums[a].lot_num);
    if (index != -1) {
      allNumbers[index].price =
        parseInt(allNumbers[index].price) + parseInt(orderNums[a].price);
    } else {
      let objectNumber = {
        lot_num: orderNums[a].lot_num,
        price: parseInt(orderNums[a].price),
      };
      allNumbers.push(objectNumber);
    }
  }
  allNumbers.sort(function (a, b) {
    var keyA = parseInt(a.lot_num),
      keyB = parseInt(b.lot_num);
    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
  allNumbers.sort(function (a, b) {
    var keyA = a.price,
      keyB = b.price;
    // Compare the 2 dates
    if (keyA > keyB) return -1;
    if (keyA < keyB) return 1;
    return 0;
  });

  return allNumbers;
};

const reflectorNums = (bil) => {
  let usetypes = [];
  if (bil.lotSubType == "lot_2") {
    if (!checkEmpty(bil.topPrice)) {
      usetypes.push({ type: "lot_2_t", key: "topPrice" });
    }
    if (!checkEmpty(bil.bottomPrice)) {
      usetypes.push({ type: "lot_2_b", key: "bottomPrice" });
    }
  } else if (bil.lotSubType == "lot_3") {
    if (!checkEmpty(bil.topPrice)) {
      usetypes.push({ type: "lot_3_t", key: "topPrice" });
    }
    if (!checkEmpty(bil.bottomPrice)) {
      usetypes.push({ type: "lot_3_b", key: "bottomPrice" });
    }
    if (!checkEmpty(bil.totPrice)) {
      usetypes.push({ type: "lot_3_tt", key: "totPrice" });
    }
  } else if (bil.lotSubType == "lot_run") {
    if (!checkEmpty(bil.runTopPrice)) {
      usetypes.push({ type: "lot_r_t", key: "runTopPrice" });
    }
    if (!checkEmpty(bil.runBottomPrice)) {
      usetypes.push({ type: "lot_r_b", key: "runBottomPrice" });
    }
  }

  let allNumbers = [];
  for (let z = 0; z < usetypes.length; z++) {
    let usetype = usetypes[z];
    let type = usetype.type;

    for (let a = 0; a < bil.nums.length; a++) {
      let num = bil.nums[a];
      let index = allNumbers.findIndex((o) => o.num == num && o.type == type);
      let price = bil[usetype.key];
      if (index != -1) {
        allNumbers[index].price =
          parseInt(allNumbers[index].price) + parseInt(price);
      } else {
        let objectNumber = {
          num: num,
          price: parseInt(price),
          type: type,
        };
        allNumbers.push(objectNumber);
      }
    }
  }
  return allNumbers;
};
export const getCheckPrevent = async (lot_date, lot, bil) => {
  let ignore = true;
  let response = {};
  if (ignore) {
    response.doneAll = true;
    return response;
  }

  let body = {
    lot_date,
    lot_id: lot.lot_id,
    nums: bil.nums,
  };
  let data = await getOrderLotApi(body);
  let orders = data.orders;
  let lotPrevent = data.lotPrevent;
  let nums_t_2 = null;
  let nums_b_2 = null;
  let nums_t_3 = null;
  let nums_b_3 = null;
  let nums_tt_3 = null;
  let nums_r_t = null;
  let nums_r_b = null;
  let allNumbers = reflectorNums(bil);
  let errorNums = [];
  if (checkEmpty(lotPrevent)) {
    response.doneAll = true;
    return response;
  }
  for (let a = 0; a < allNumbers.length; a++) {
    let numOb = allNumbers[a];
    let num = allNumbers[a].num;
    if (bil.lotSubType == "lot_2") {
      if (!checkEmpty(bil.topPrice)) {
        if (nums_t_2 == null) {
          nums_t_2 = getLotsByTypeV2(
            "lot_top_price",
            "lot_2",
            orders,
            lot.lot_id
          );
        }
        console.log("numOb", numOb);
        console.log("lotPrevent", lotPrevent);
        let ob = nums_t_2.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }

        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_2_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot 2 t", nums_t_2);
      }
      if (!checkEmpty(bil.bottomPrice)) {
        if (nums_b_2 == null) {
          nums_b_2 = getLotsByTypeV2(
            "lot_bottom_price",
            "lot_2",
            orders,
            lot.lot_id
          );
        }
        let ob = nums_b_2.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_2_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot 2 b", nums_b_2);
      }
    } else if (bil.lotSubType == "lot_3") {
      if (!checkEmpty(bil.topPrice)) {
        if (nums_t_3 == null) {
          nums_t_3 = getLotsByTypeV2(
            "lot_top_price",
            "lot_3",
            orders,
            lot.lot_id
          );
        }
        let ob = nums_t_3.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_3_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot 3 t", nums_t_3);
      }
      if (!checkEmpty(bil.bottomPrice)) {
        if (nums_b_3 == null) {
          nums_b_3 = getLotsByTypeV2(
            "lot_bottom_price",
            "lot_3",
            orders,
            lot.lot_id
          );
        }
        let ob = nums_b_3.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_3_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot 3 b", nums_b_3);
      }
      if (!checkEmpty(bil.totPrice)) {
        if (nums_tt_3 == null) {
          nums_tt_3 = getLotsByTypeV2("lot_tot_price", "", orders, lot.lot_id);
        }
        let ob = nums_tt_3.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_3_tot)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot 3 tt", nums_tt_3);
      }
    } else if (bil.lotSubType == "lot_run") {
      if (!checkEmpty(bil.runTopPrice)) {
        if (nums_r_t == null) {
          nums_r_t = getLotsByTypeV2(
            "lot_run_top_price",
            "",
            orders,
            lot.lot_id
          );
        }
        let ob = nums_r_t.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_run_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot r t", nums_r_t);
      }
      if (!checkEmpty(bil.runBottomPrice)) {
        if (nums_r_b == null) {
          nums_r_b = getLotsByTypeV2(
            "lot_run_bottom_price",
            "lot_2",
            orders,
            lot.lot_id
          );
        }
        let ob = nums_r_b.find((no) => no.lot_num == num);
        let pricedb = 0;
        if (!checkEmpty(ob)) {
          pricedb = ob.price;
        }
        let newprice = parseInt(pricedb) + parseInt(numOb.price);
        if (newprice > parseInt(lotPrevent.lot_run_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
        console.log("nums lot r b", nums_r_b);
      }
    }
  }

  console.log("errorNums", errorNums);

  let numberErrors = [];
  for (let a = 0; a < errorNums.length; a++) {
    if (!numberErrors.includes(errorNums[a].num)) {
      numberErrors.push(errorNums[a].num);
    }
  }

  // let errorNumsFinal = errorNums.filter((element, index) => {
  //   return errorNums.indexOf(element) === index;
  // });
  console.log("errorNums", errorNums);
  console.log("numberErrors", numberErrors);

  if (errorNums.length == 0) response.doneAll = true;
  else response.doneAll = false;
  response.errorNumObjects = errorNums;
  response.numberErrors = numberErrors;

  return response;
};

export const savePostUtilApi = (subpath, body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/" + subpath;
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const getLotCloses = (id) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL + "/v1/get-lot-close?lot_id=" + id;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getLotClosesDate = (id, lot_date) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      "/v1/get-lot-close-date?lot_id=" +
      id +
      "&lot_date=" +
      lot_date;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const getPreventNumbersDate = (id, lot_date) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      "/v1/get-prevent-number-date?lot_id=" +
      id +
      "&lot_date=" +
      lot_date;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const checkCloseNumFn = (bil, lotCloses) => {
  // let ignore = true;
  let response = {};

  let allNumbers = reflectorNums(bil);
  let errorNums = [];
  if (checkEmpty(lotCloses) || lotCloses.length == 0) {
    response.doneAll = true;
    return response;
  }
  for (let a = 0; a < allNumbers.length; a++) {
    let numOb = allNumbers[a];
    let num = allNumbers[a].num;
    if (bil.lotSubType == "lot_2") {
      for (let b = 0; b < lotCloses.length; b++) {
        if (
          lotCloses[b].close_number == num &&
          bil.lotSubType == lotCloses[b].close_number_type
        ) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
    } else if (bil.lotSubType == "lot_3") {
      for (let b = 0; b < lotCloses.length; b++) {
        if (
          lotCloses[b].close_number == num &&
          bil.lotSubType == lotCloses[b].close_number_type
        ) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
    }
  }

  console.log("errorNums", errorNums);

  let numberErrors = [];
  for (let a = 0; a < errorNums.length; a++) {
    if (!numberErrors.includes(errorNums[a].num)) {
      numberErrors.push(errorNums[a].num);
    }
  }

  // let errorNumsFinal = errorNums.filter((element, index) => {
  //   return errorNums.indexOf(element) === index;
  // });
  console.log("errorNums", errorNums);
  console.log("numberErrors", numberErrors);

  if (errorNums.length == 0) response.doneAll = true;
  else response.doneAll = false;
  response.errorNumObjects = errorNums;
  response.numberErrors = numberErrors;

  return response;
};

export const getTextType = (type) => {
  if (type == "lot_2") {
    return "2 ตัวตรง";
  } else if (type == "lot_3_top") {
    return "3 ตัวตรง";
  } else if (type == "lot_3_tot") {
    return "3 ตัวโต๊ด";
  }
};

export const getRmNumday = (day) => {
  if (day == 0) {
    return 6;
  } else if (day == 1) {
    return 0;
  } else if (day == 2) {
    return 1;
  } else if (day == 3) {
    return 2;
  } else if (day == 4) {
    return 3;
  } else if (day == 5) {
    return 4;
  } else if (day == 6) {
    return 5;
  }
};

const getPriceBil = (lotBils, lotSubType, key, numS) => {
  let price = 0;
  for (let z = 0; z < lotBils.length; z++) {
    let allNumbers = reflectorNums(lotBils[z]);
    for (let a = 0; a < allNumbers.length; a++) {
      let numOb = allNumbers[a];
      let num = numOb.num;
      if (lotBils[z].lotSubType == lotSubType && num == numS) {
        let p = checkEmpty(numOb.price) ? 0 : parseInt(numOb.price);
        price = price + p;
      }
    }
  }
  return price;
};

export const getCheckPreventV2 = async (
  lot_date,
  lot,
  bil,
  lotPrevent,
  lotBils
) => {
  // let ignore = true;
  // if (ignore) {
  //   response.doneAll = true;
  //   return response;
  // }

  let response = {};
  if (checkEmpty(lotPrevent)) {
    response.doneAll = true;
    return response;
  }

  // console.log("bil", bil);
  // console.log("lotPrevent", lotPrevent);
  let callApi = false;
  if (bil.lotSubType == "lot_2") {
    if (!checkEmpty(bil.topPrice)) {
      if (parseInt(lotPrevent?.lot_2_top) > 0) callApi = true;
    }
    if (!checkEmpty(bil.bottomPrice)) {
      if (parseInt(lotPrevent?.lot_2_bottom) > 0) callApi = true;
    }
  } else if (bil.lotSubType == "lot_3") {
    if (!checkEmpty(bil.topPrice)) {
      if (parseInt(lotPrevent?.lot_3_top) > 0) callApi = true;
    }
    if (!checkEmpty(bil.bottomPrice)) {
      if (parseInt(lotPrevent?.lot_3_bottom) > 0) callApi = true;
    }
    if (!checkEmpty(bil.totPrice)) {
      if (parseInt(lotPrevent?.lot_3_tot) > 0) callApi = true;
    }
  } else if (bil.lotSubType == "lot_run") {
    if (!checkEmpty(bil.runTopPrice)) {
      if (parseInt(lotPrevent?.lot_run_top) > 0) callApi = true;
    }
    if (!checkEmpty(bil.runBottomPrice)) {
      if (parseInt(lotPrevent?.lot_run_bottom) > 0) callApi = true;
    }
  }
  if (!callApi) {
    response.doneAll = true;
    return response;
  }

  let body = {
    datefrom: lot_date,
    dateto: lot_date,
    lot_id: lot.lot_id,
    nums: bil.nums,
  };
  let allNumbers = reflectorNums(bil);
  let dataNumbers = await getOrderLotApiV2(body);
  // console.log("lotPrevent", lotPrevent);
  // console.log("dataNumbers", dataNumbers);
  // console.log("allNumbers", allNumbers);
  let errorNums = [];
  for (let a = 0; a < allNumbers.length; a++) {
    let numOb = allNumbers[a];
    let num = allNumbers[a].num;
    if (bil.lotSubType == "lot_2") {
      if (!checkEmpty(bil.topPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_2_top"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_2", "topPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_2_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
      if (!checkEmpty(bil.bottomPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_2_bottom"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_2", "bottomPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_2_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
    } else if (bil.lotSubType == "lot_3") {
      if (!checkEmpty(bil.topPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_3_top"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_3", "topPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_3_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
      if (!checkEmpty(bil.bottomPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_3_bottom"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_3", "bottomPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_3_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
      if (!checkEmpty(bil.totPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_3_tot"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_3", "totPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_3_tot)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
    } else if (bil.lotSubType == "lot_run") {
      if (!checkEmpty(bil.runTopPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_run_top"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_run", "runTopPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_run_top)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
      if (!checkEmpty(bil.runBottomPrice)) {
        let dataNumber = dataNumbers.find(
          (o) => o.lot_num == num && o.lot_type_type == "lot_run_bottom"
        );
        let pricedb = 0;
        if (!checkEmpty(dataNumber)) {
          pricedb = dataNumber.sum_price;
        }
        let priceBil = getPriceBil(lotBils, "lot_run", "runBottomPrice", num);
        let newprice =
          parseInt(pricedb) + parseInt(numOb.price) + parseInt(priceBil);
        if (newprice > parseInt(lotPrevent.lot_run_bottom)) {
          errorNums.push({ num: num, type: numOb.type });
        }
      }
    }
  }

  console.log("errorNums", errorNums);
  let numberErrors = [];
  for (let a = 0; a < errorNums.length; a++) {
    if (!numberErrors.includes(errorNums[a].num)) {
      numberErrors.push(errorNums[a].num);
    }
  }

  if (errorNums.length == 0) response.doneAll = true;
  else response.doneAll = false;
  response.errorNumObjects = errorNums;
  response.numberErrors = numberErrors;

  return response;
};

export const getOrderLotApiV2 = async (body) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthorization(),
      },
    };
    let link =
      process.env.REACT_APP_SERVICE_URL + "/v1/get-lot-order-date-prevent-v2";
    console.log("link:", link);
    const data = body;
    axios
      .post(link, data, config)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch(function (error) {
        reject();
      })
      .finally(function () {
        // always executed
      });
  });
};

export const getLotTotalDataApi = (datefrom, dateto, acUsername) => {
  return new Promise((resolve, reject) => {
    let link =
      process.env.REACT_APP_SERVICE_URL +
      `/v1/get-lot-order-total?datefrom=${datefrom}&&dateto=${dateto}&&username=${acUsername}`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("getAboutLot err=>", e);
        reject();
      });
  });
};

export const testConn = () => {
  return new Promise((resolve, reject) => {
    let link = process.env.REACT_APP_SERVICE_URL + `/v1//test-conn`;
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then((res) => {
        if (res.status != 200) {
          reject();
        } else {
          resolve(res.data.data);
        }
      })
      .catch((e) => {
        console.log("testConn err=>", e);
        reject();
      });
  });
};
